/**
 * Application-wide constants
 */

// Ringba-provided phone number used for Dynamic Number Insertion (DNI)
export const RINGBA_DNI_PHONE = "+18449104158";
export const TX_RINGBA_DNI_PHONE = "+18333395088";

export const CALL_FORWARD_STATIC_PHONE = "+18444711189";

export const PHONE_WORKSTREAM_QUERY_PARAM = "workstream";

export type PhoneWorkstream = "tx";

export function parsePhoneWorkstream(
  value: string | null | undefined,
): PhoneWorkstream | undefined {
  return value === "tx" ? value : undefined;
}

export function getRingbaDniPhone(workstream?: PhoneWorkstream): string {
  return workstream === "tx" ? TX_RINGBA_DNI_PHONE : RINGBA_DNI_PHONE;
}

export function getPhoneWorkstreamQueryParams(
  workstream?: PhoneWorkstream,
): Record<string, string> {
  return workstream ? { [PHONE_WORKSTREAM_QUERY_PARAM]: workstream } : {};
}

// Utility Line Warranty (ULW) claims phone number
// As of writing, this phone is defined in RingCentral and assigned to Guardian Service ULW IVR
export const ULW_CLAIMS_PHONE = "+18444367737";

/**
 * Formats a phone number in E.164 format to US display format (XXX) XXX-XXXX
 * @param phoneNumber - Phone number in E.164 format (e.g., +18449104158)
 * @returns Formatted phone number (e.g., (844) 910-4158)
 */
export function formatPhoneNumber(phoneNumber: string): string {
  // Remove the + and country code (assumes US numbers starting with +1)
  const digits = phoneNumber.replace(/^\+1/, "");

  // Format as (XXX) XXX-XXXX
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // Fallback: return original if format is unexpected
  return phoneNumber;
}
